import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { pick } from 'ramda'

import { placesClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertPlaceLevel($input: PlaceLevelInput) {
    upsertPlaceLevel(input: $input) {
      id
    }
  }
`

const cleanRequest = pick(['id', 'name', 'entity'])

const validate = (form, setErrors) => {
  const errors = [...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' })]

  setErrors(errors)
  return errors.length === 0
}

export const useSavePlaceLevel = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['PlaceLevels'], client: placesClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
